import React, { useEffect, useState }  from 'react';
import styled from 'styled-components';
import { TextBtn } from '../Inputs/TextBtn';
const Styles = styled.div`
  margin: 0.5rem 0;
  width: calc(100% - calc(var(--universal-pad) * 2) - 0rem);
  margin: 0 var(--universal-pad);
  padding: 0;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  .button {
    min-width: 200px;
  }
`
export default function InstallApp33 (props){
  const {data: dataRaw} = props;
  const data = JSON.parse(dataRaw);
  const [event, setEvent] = useState([]);
  const [showInstall, setShowInstall] = useState(false);
  const [serviceWorker, setServiceWorker] = useState(false);
  const [PushSubs, setPushSubs] = useState(false);

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', beforeinstallprompt);
    return () => {
        window.removeEventListener('beforeinstallprompt', beforeinstallprompt);
    }
}, [])
  const beforeinstallprompt = (e) => {
    e.preventDefault();
    setShowInstall(e);
    console.log(e)
    
    setEvent(prev => [...prev, 'ready for install']);
  }
  const checkIsMobile = () => {
    if (
        navigator.userAgent.match(/Android/i) || 
        navigator.userAgent.match(/webOS/i) || 
        navigator.userAgent.match(/iPhone/i) || 
        navigator.userAgent.match(/iPad/i) || 
        navigator.userAgent.match(/iPod/i) || 
        navigator.userAgent.match(/BlackBerry/i) || 
        navigator.userAgent.match(/Windows Phone/i)
    ) {
        return true ;
    } else {
        return false ;
    }   
  }
  const isMobile = checkIsMobile();
  let displayMode = 'browser-tab';
  if (window.matchMedia('(display-mode: standalone)').matches) {
      displayMode = 'standalone';
  }
  let showInstallBtn = false;
  let showError = false;
  if(isMobile && showInstall && displayMode === "browser-tab"){
    showInstallBtn = true;
  }
  if(displayMode === "browser-tab" && !showInstallBtn){
    showError = "امکان نصب اپلیکیشن برای این دستگاه وحود ندارد"
  }
  if(displayMode === "standalone"){
    showError = "شما اپلیکیشن را نصب کرده اید"
  }
  return (
    <Styles>
      <div className='button'>
        {
          showInstallBtn ? (
            <TextBtn
              text={"نصب اپلیکیشن"}
              onclick={() => {
                showInstall.prompt();
              }}
            />
          ) : ""
        }
        {
          showError ? (
            showError
          ) : ""
        }
      </div>
    </Styles>
  )
}

